var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30484",
    "data-name": "Group 30484",
    transform: "translate(10704 -17338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30485",
    "data-name": "Group 30485"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14180",
    "data-name": "Rectangle 14180",
    width: 32,
    height: 32,
    transform: "translate(-10704 17338)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(-10700 17341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14224",
    "data-name": "Rectangle 14224",
    width: 8,
    height: 8,
    transform: "translate(2 3)",
    fill: "none",
    stroke: "#1447d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14225",
    "data-name": "Rectangle 14225",
    width: 8,
    height: 8,
    transform: "translate(14 3)",
    fill: "none",
    stroke: "#1447d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14226",
    "data-name": "Rectangle 14226",
    width: 8,
    height: 8,
    transform: "translate(14 15)",
    fill: "none",
    stroke: "#1447d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14227",
    "data-name": "Rectangle 14227",
    width: 8,
    height: 8,
    transform: "translate(2 15)",
    fill: "none",
    stroke: "#1447d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeActive);
export default __webpack_public_path__ + "static/media/themeActive.5149daa9.svg";
export { ForwardRef as ReactComponent };